<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar></app-sidebar>

  <div class="content-page">
    <div class="content">
      <div class="content-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">PayEXAP</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/credit-notes">Credit Notes</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/credit-note-detail">Credit Note Detail</a>
            </span>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="pane-header">
                <h4 class="mt-2 mb-4">Credit Note Details</h4>
              </div>
              <ng-container *ngIf="loading">
                <div class="text-center">
                  <app-loader></app-loader>
                </div>
              </ng-container>
              <ng-container *ngIf="!loading">
                <div class="row">
                  <div class="col-md-5">
                    <div class="detials-pane invoice">
                      <div class="row">
                        <div class="col-12">
                          <div *ngIf="credit_note?.barcode !== null" class="invoice-item mb-2 row">
                            <div class="col-5">
                              <h6>Barcode</h6>
                            </div>
                            <div class="col-7 mt-2">
                              {{ credit_note.barcode }}
                            </div>
                          </div>

                          <div class="invoice-item mb-2 row">
                            <div class="col-5">
                              <h6>CN / DN No</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ credit_note.docNo }}
                              </p>
                            </div>
                          </div>

                          <div *ngIf="credit_note.irn !== null" class="invoice-item mb-2 row">
                            <div class="col-5">
                              <h6>IRN</h6>
                            </div>
                            <div class="col-7">
                              {{ credit_note.docDetail.irn }}
                            </div>
                          </div>

                          <div class="invoice-item mb-2 row">
                            <div class="col-5">
                              <h6>Credit Note Amount</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ credit_note.docAmount | inrdisplay }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice-item mb-2 row">
                            <div class="col-5">
                              <h6>Credit Note Date</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ credit_note?.docDate | date : "dd/MM/yyyy" }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice-item mb-2 row">
                            <div class="col-5">
                              <h6>Tax Registration Number</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ credit_note.docDetail.docGstin }}
                              </p>
                            </div>
                          </div>

                          <div class="invoice-item mb-2 row">
                            <div class="col-5">
                              <h6>CN/DN URL</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                <a target="_blank" href="{{ credit_note.file_link }}" rel="noopener"> View PDF </a>
                              </p>
                            </div>
                          </div>

                         

                          <div *ngIf="credit_note.poNo !== ''" class="invoice-item mb-2 row">
                            <div class="col-5">
                              <h6>PO No</h6>
                            </div>
                            <div class="col-7">
                              <p class="txt-adjust">
                                {{ credit_note.poNo }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <h5 class="pb-4 status-pane-header">
                      Invoice Status History
                      <span (click)="statusInfo()"><i class="ri-information-fill"></i></span>
                    </h5>
                    <div class="status-pane">
                      <ng-container *ngIf="credit_note.gpStatus.statusHistory.length !== 0">
                        <table aria-describedby="invoice-status" class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint text-left invoice-status">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Status</th>
                              <th>Owner</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let status of credit_note.gpStatus.statusHistory">
                              <ng-container *ngIf="status.timestamp !== ''">
                                <td [ngClass]="[status.timestamp !== '' ? 'default' : 'text-shade', status.status === 'REJECTED' ? 'rejected' : 'normal']">
                                  {{ status.timestamp }}
                                </td>
                                <td [ngClass]="[status.timestamp !== '' ? 'default' : 'text-shade', status.status === 'REJECTED' ? '' : 'normal']">
                                  <span>
                                    {{ status.meta.invoice_status }}
                                  </span>

                                  <span *ngIf="status.status === 'Rejected' || status.status === 'rejected'">
                                    <ng-container *ngIf="credit_note.reference_details.docType === 'PO2S - PO2S'">
                                      <i *ngIf="credit_note.rejection1" class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ credit_note.rejections.rej1.reason }}"></i>
                                      <i *ngIf="credit_note.rejection2" class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ credit_note.rejections.rej2.reason }}"></i>
                                    </ng-container>
                                  </span>

                                  <span *ngIf="status.status === 'Pending_submission'">
                                    <ng-container *ngIf="credit_note.reference_details.docType === 'PO2S - PO2S'">
                                      <i
                                        class="ri-information-fill"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="This invoice is pending level 1 approval by the shipping team before processing."
                                      ></i>
                                    </ng-container>

                                    <ng-container *ngIf="credit_note.reference_details.docType !== 'PO2S - PO2S'">
                                      <i
                                        class="ri-information-fill"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Sorry, there may be an issue. We will retry automatically later. If it has been more than 24hrs, contact support."
                                      ></i>
                                    </ng-container>
                                  </span>
                                </td>
                                <td [ngClass]="status.timestamp !== '' ? 'default' : 'text-shade'">
                                  <ng-container *ngIf="status.status === 'Pending_submission'">Vendor</ng-container>
                                  <ng-container *ngIf="status.status === 'SUBMITTED'">Vendor</ng-container>
                                  <ng-container *ngIf="status.status === 'ACCEPTED'">Plant</ng-container>
                                  <ng-container *ngIf="status.status === 'APPROVED'">Plant</ng-container>
                                  <ng-container *ngIf="status.status === 'IN_PROCESSING'">GBS</ng-container>
                                  <ng-container *ngIf="status.status === 'IN_QUERY'">JSW User</ng-container>
                                  <ng-container *ngIf="status.status === 'POSTED'">GBS</ng-container>
                                  <ng-container *ngIf="status.status === 'CLEARED'">GBS</ng-container>

                                  <ng-container *ngIf="status.status === 'PAID'">GBS</ng-container>
                                  <span [ngClass]="status.status === 'REJECTED' ? 'rejected' : 'normal'" *ngIf="status.status === 'REJECTED'">GBS</span>

                                  <ng-container *ngIf="status.status === 'PENDING_SHIPPING_APPROVAL'">Vendor Portal</ng-container>

                                  <ng-container *ngIf="status.status === 'PENDING_VESON_APPROVAL'">Shipping Team</ng-container>
                                </td>
                                <td>
                                  <i *ngIf="status.status !== 'REJECTED'" [ngClass]="status.timestamp !== '' ? 'checked' : 'default'" class="ri-checkbox-circle-fill"> </i>
                                  <i *ngIf="status.status === 'REJECTED'" [ngClass]="status.timestamp !== '' ? 'checked rejected' : 'default'" class="ri-close-circle-fill"> </i>
                                </td>
                              </ng-container>
                            </tr>
                            <tr *ngFor="let status of credit_note.gpStatus.statusHistory">
                              <ng-container *ngIf="status.creation_date !== '' && status.status === 'Cleared' && status.payment_adjusted === 'TRUE'">
                                <td>
                                  {{ status.creation_date_sys | date }}
                                  {{ status.creation_date_sys | date : "shortTime" }}
                                </td>

                                <td>
                                  <span class="adjust-text"> Payment Adjusted</span>
                                  <span>
                                    <i
                                      class="ri-information-fill"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="This Invoice has been cleared against an open debit. Check Payment Advice for further details"
                                    ></i
                                  ></span>
                                </td>
                                <td>GBS</td>
                                <td>
                                  <i *ngIf="status.status !== 'REJECTED'" [ngClass]="status.timestamp !== '' ? 'invoice-status checked' : 'default'" class="ri-checkbox-circle-fill"> </i>
                                  <i *ngIf="status.status === 'REJECTED'" [ngClass]="status.timestamp !== '' ? 'invoice-status checked rejected' : 'default'" class="ri-close-circle-fill"></i>
                                </td>
                              </ng-container>
                            </tr>
                          </tbody>
                        </table>
                      </ng-container>

                      <div *ngIf="credit_note?.gpStatus?.statusHistory.length == 0">
                        <table aria-describedby="invoice?-status" class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint text-left invoice?-status">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Status</th>
                              <th>Owner</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <ng-container *ngIf="credit_note?.gpStatus.currStatus.timestamp !== ''">
                                <td [ngClass]="[credit_note?.gpStatus.currStatus.timestamp !== '' ? 'default' : 'text-shade', credit_note?.gpStatus.currStatus.status === 'Rejected' ? 'rejected' : 'normal']">
                                  {{ credit_note?.gpStatus.currStatus.timestamp }}
                                </td>
                                <td [ngClass]="[credit_note?.gpStatus.currStatus.timestamp !== '' ? 'default' : 'text-shade', credit_note?.gpStatus.currStatus.status === 'Rejected' ? 'rejected' : 'normal']">
                                  Pending Submission
                                </td>
                                <td [ngClass]="credit_note?.gpStatus.currStatus.timestamp !== '' ? 'default' : 'text-shade'">
                                  GBS
                                </td>
                                <td>
                                  <i
                                    *ngIf="credit_note?.gpStatus.currStatus.status !== 'REJECTED'"
                                    [ngClass]="credit_note?.gpStatus.currStatus.timestamp !== '' ? 'checked' : 'default'"
                                    class="ri-checkbox-circle-fill"
                                  >
                                  </i>
                                  <i
                                    *ngIf="credit_note?.gpStatus.currStatus.status === 'REJECTED'"
                                    [ngClass]="credit_note?.gpStatus.currStatus.timestamp !== '' ? 'checked rejected' : 'default'"
                                    class="ri-checkbox-circle-fill"
                                  >
                                  </i>
                                </td>
                              </ng-container>
                            </tr>
                            <tr *ngFor="let status of credit_note?.statuses">
                              <ng-container *ngIf="status.timestamp !== '' && status.status === 'Cleared' && status.payment_adjusted === 'TRUE'">
                                <td>
                                  {{ status.timestamp }}
                                </td>

                                <td>
                                  <span class="adjust-text"> Payment Adjusted</span>
                                  <span>
                                    <i
                                      class="ri-information-fill"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title="This CN/DN has been cleared against an open debit. Check Payment Advice for further details"
                                    ></i
                                  ></span>
                                </td>
                                <td>GBS</td>
                                <td>
                                  <i class="checked ri-checkbox-circle-fill"> </i>
                                </td>
                              </ng-container>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="loader-wrapper" *ngIf="showing">
            <div class="loader-content status-sequence">
              <div class="loader-text text-center my-3">
                <h4>Invoice Status Sequence</h4>
              </div>
              <div class="loader-body">
                <div class="container">
                  <!-- <div class="text-brief text-center mb-3">
                                        All statuses as displayed on the UI
                                        today with their owner and explanations
                                    </div> -->
                  <table aria-describedby="invoice-status" class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint text-left">
                    <thead>
                      <tr>
                        <th class="text-left">Status</th>
                        <th class="text-left">Owner</th>
                        <th class="text-left">Brief</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Pending Submission</td>
                        <td>Vendor</td>
                        <td>The invoice has been successfully uploaded but not yet submitted.</td>
                      </tr>
                      <tr>
                        <td>Submitted</td>
                        <td>Vendor</td>
                        <td>The invoice has been submitted and sent to JSW.</td>
                      </tr>
                      <tr>
                        <td>Accepted</td>
                        <td>Plant</td>
                        <td>The invoice has been accepted by JSW.</td>
                      </tr>
                      <tr>
                        <td>Approved</td>
                        <td>Plant</td>
                        <td>The invoice has been approved by user department for further processing.</td>
                      </tr>
                      <tr>
                        <td>In Processing</td>
                        <td>GBS</td>
                        <td>The invoice is in processing with GBS.</td>
                      </tr>
                      <tr>
                        <td>In Query</td>
                        <td>JSW User</td>
                        <td>There could be an issue with your Invoice. Reach out to the JSW support desk if you have not received any related communication.</td>
                      </tr>
                      <tr>
                        <td>Posted</td>
                        <td>GBS</td>
                        <td>The invoice has been processed and sent to Audit for final review.</td>
                      </tr>
                      <tr>
                        <td>Cleared</td>
                        <td>GBS</td>
                        <td>Invoice cleared for payment.</td>
                      </tr>
                      <tr>
                        <td>Paid</td>
                        <td>GBS</td>
                        <td>Invoice paid and funds transferred to vendor’s account.</td>
                      </tr>

                      <tr>
                        <td>Rejected</td>
                        <td>GBS</td>
                        <td>The invoice has been rejected. Reach out to the JSW support desk if you have not received any related communication.</td>
                      </tr>
                      <!-- <tr>
                                        <td>Payment 
                                            Adjusted</td>
                                        <td>GBS</td>
                                        <td>
                                            Payment of invoice adjusted
                                        </td>
                                    </tr> -->
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="loader-footer text-center my-3">
                <button class="btn btn-default" (click)="closeStatusInfo()">OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
